// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TPublicB2cV3GetOffersRequest,
  TPublicB2cV3GetOffersModel,
  IMappers,
  TPublicB2cV3GetOffersResponse_,
  TPublicB2cV3GetOffersResponse,
  TPublicB2cV3GetOffersResponse_1,
  TPublicB2cV3GetOffersResponseError,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';

export function createPublicB2cV3GetOffersModel(parameters: TPublicB2cV3GetOffersRequest): TPublicB2cV3GetOffersModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'mortgage-broker-calculator',
    pathApi: '/b2c/v3/get-offers/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface IPublicB2cV3GetOffersOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TPublicB2cV3GetOffersRequest;
}

export async function fetchPublicB2cV3GetOffers<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IPublicB2cV3GetOffersOptions<TResponse200, TResponse400>): Promise<
  TPublicB2cV3GetOffersResponse | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createPublicB2cV3GetOffersModel(parameters),
    config,
  )) as FetchResponse<TPublicB2cV3GetOffersResponse_>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as TPublicB2cV3GetOffersResponse_1, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as TPublicB2cV3GetOffersResponseError, headers);
    }
  }
  return {
    statusCode,
    response,
    headers: Array.from(headers),
  } as TPublicB2cV3GetOffersResponse;
}
